module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[92]579.12eabb9.woff2";